import React from 'react';

const DeleteProductConfirmModal = ({
  productWasDeleted,
  deleteError,
  onClose,
  renderDeleteButton
}) => {
  return (
    <div className="modal" tabIndex="-1" role="dialog" id="confirmDeleteModal">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Деактивація товару</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {!productWasDeleted ? (
              <p className="mb-0">
                Товар буде переведено в статус <strong>«Не активний»</strong>.
                <br />
                <span className="small text-muted">
                  Категорії, фото та історія залишаються. На сайті товар не відображається.
                </span>
              </p>
            ) : null}
            {deleteError ? (
              <div className="alert alert-danger mb-0" role="alert">{deleteError}</div>
            ) : null}
            {productWasDeleted ? (
              <div className="alert alert-success text-center mb-0" role="alert">
                Статус змінено на «Не активний»
              </div>
            ) : null}
          </div>
          <div className="modal-footer">
            {renderDeleteButton()}
            <button type="button" className="btn btn-success" data-dismiss="modal" onClick={onClose}>
              Закрити
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteProductConfirmModal;
